import "./App.css";
import Club from "./Club";
import Faq from "./Faq.js";
import Festival from "./Festival.js";
import Footer from "./Footer.js";
import Hero from "./Hero.js";
import Navbar from "./Navbar.js";
import RoadMap from "./RoadMap.js";
function App() {
	return (
		<div className="w-full">
			<Navbar />
			<Hero />
			<Club />
			<Festival />
			<RoadMap />
			<Faq />
			<Footer />
		</div>
	);
}
export default App;
